import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

// Create axios instance with base configuration
const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor to include JWT token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Unauthorized - clear token and redirect to login
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// ============ Authentication API ============

export const authAPI = {
  register: async (name, email, password) => {
    const response = await api.post('/auth/register', { name, email, password });
    return response.data;
  },

  login: async (email, password) => {
    const response = await api.post('/auth/login', { email, password });
    return response.data;
  },

  getCurrentUser: async () => {
    const response = await api.get('/auth/me');
    return response.data;
  },
};

// ============ PDF Conversion API ============

export const conversionAPI = {
  uploadPDF: async (file, onUploadProgress) => {
    const formData = new FormData();
    formData.append('file', file);

    const response = await api.post('/convert/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onUploadProgress,
    });
    return response.data;
  },

  getStatus: async (conversionId) => {
    const response = await api.get(`/convert/status/${conversionId}`);
    return response.data;
  },

  downloadFile: (conversionId) => {
    return `${API_BASE}/convert/download/${conversionId}`;
  },

  getHistory: async () => {
    const response = await api.get('/convert/history');
    return response.data;
  },
};

// ============ Subscription API ============

export const subscriptionAPI = {
  createCheckoutSession: async () => {
    const response = await api.post('/subscription/create-checkout');
    return response.data;
  },

  getStatus: async () => {
    const response = await api.get('/subscription/status');
    return response.data;
  },
};

// ============ Contact API ============

export const contactAPI = {
  submit: async (formData) => {
    const response = await api.post('/contact', formData);
    return response.data;
  },
};

export default api;
